"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _termsModule = require("./termsModule");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var createHTMLMarkup = function createHTMLMarkup(html) {
  return {
    __html: html
  };
};
var TermsPage = /*#__PURE__*/function (_React$Component) {
  function TermsPage() {
    _classCallCheck(this, TermsPage);
    return _callSuper(this, TermsPage, arguments);
  }
  _inherits(TermsPage, _React$Component);
  return _createClass(TermsPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.fetchLOAContent();
    }
  }, {
    key: "render",
    value: function render() {
      var loaHtml = this.props.loaHtml;
      var re = /<style>\s+(.*)\s+<\/style>/;
      loaHtml = loaHtml && loaHtml.replace(re, '$1');
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          padding: '20px',
          fontSize: '1.2em',
          lineHeight: '1.6'
        },
        dangerouslySetInnerHTML: createHTMLMarkup(loaHtml)
      });
    }
  }]);
}(_react.default.Component);
TermsPage.propTypes = {
  fetchLOAContent: _propTypes.default.func.isRequired
};
function mapStateToProps(state) {
  var _state$terms = state.terms,
    _state$terms2 = _state$terms === void 0 ? {} : _state$terms,
    _state$terms2$loa$con = _state$terms2.loa.content,
    _state$terms2$loa$con2 = _state$terms2$loa$con === void 0 ? {} : _state$terms2$loa$con,
    loaHtml = _state$terms2$loa$con2.html;
  return {
    loaHtml: loaHtml
  };
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchLOAContent: _termsModule.fetchLOAContent
})(TermsPage);